module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('nav-bar'), _vm._v(" "), _c('div', {
    staticClass: "pt-4 mx-3"
  }, [(_vm.companyUID === 'e58ff614-8449-4c3e-90b8-b42a48c2972b') ? _c('div', {
    staticClass: "card mb-3"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h3', {
    staticClass: "my-2"
  }, [_vm._v(" " + _vm._s(_vm.$t('Search.archive_title')))])]), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('regular-input', {
    staticClass: "col-12 col-sm-6 col-lg-3 form-group",
    attrs: {
      "value": _vm.searchArchive.id,
      "type": "text",
      "placeholder": _vm.$t('Search.order')
    },
    on: {
      "input": function($event) {
        _vm.searchArchive.id = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('button', {
    staticClass: "btn btn-kne-orange",
    on: {
      "click": function($event) {
        _vm.submitSearchArchive()
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('Search.submit')) + "\n            ")])])], 1)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h3', {
    staticClass: "my-2"
  }, [_vm._v(" " + _vm._s(_vm.$t('Search.title')))])]), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('regular-input', {
    staticClass: "col-12 col-sm-6 col-lg-3 form-group",
    attrs: {
      "value": _vm.search.id,
      "type": "text",
      "placeholder": _vm.$t('Search.order')
    },
    on: {
      "input": function($event) {
        _vm.search.id = $event
      }
    }
  }), _vm._v(" "), _c('regular-input', {
    staticClass: "col-12 col-sm-6 col-lg-3 form-group",
    attrs: {
      "value": _vm.search.VIN,
      "type": "text",
      "placeholder": _vm.$t('Search.VIN')
    },
    on: {
      "input": function($event) {
        _vm.search.VIN = $event
      }
    }
  }), _vm._v(" "), _c('regular-input', {
    staticClass: "col-12 col-sm-6 col-lg-3 form-group",
    attrs: {
      "value": _vm.search.referenceNumber,
      "type": "text",
      "placeholder": _vm.$t('Search.reference')
    },
    on: {
      "input": function($event) {
        _vm.search.referenceNumber = $event
      }
    }
  }), _vm._v(" "), _c('regular-input', {
    staticClass: "col-12 col-sm-6 col-lg-3 form-group",
    attrs: {
      "value": _vm.search.source,
      "type": "text",
      "placeholder": _vm.$t('Search.source')
    },
    on: {
      "input": function($event) {
        _vm.search.source = $event
      }
    }
  }), _vm._v(" "), _c('regular-input', {
    staticClass: "col-12 col-sm-6 col-lg-3 form-group",
    attrs: {
      "value": _vm.search.pickup,
      "type": "text",
      "placeholder": _vm.$t('Search.pickup')
    },
    on: {
      "input": function($event) {
        _vm.search.pickup = $event
      }
    }
  }), _vm._v(" "), _c('regular-input', {
    staticClass: "col-12 col-sm-6 col-lg-3 form-group",
    attrs: {
      "value": _vm.search.delivery,
      "type": "text",
      "placeholder": _vm.$t('Search.delivery')
    },
    on: {
      "input": function($event) {
        _vm.search.delivery = $event
      }
    }
  }), _vm._v(" "), _c('regular-input', {
    staticClass: "col-12 col-sm-6 col-lg-3 form-group",
    attrs: {
      "value": _vm.search.billing,
      "type": "text",
      "placeholder": _vm.$t('Search.billing')
    },
    on: {
      "input": function($event) {
        _vm.search.billing = $event
      }
    }
  }), _vm._v(" "), _c('regular-select', {
    staticClass: "col-12 col-sm-6 col-lg-3 form-group",
    attrs: {
      "value": _vm.search.status,
      "placeholder": _vm.$t('Search.status.status')
    },
    on: {
      "change": function($event) {
        _vm.search.status = $event
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "Dispatch"
    }
  }, [_vm._v(_vm._s(_vm.$t('Search.status.dispatch')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Pick"
    }
  }, [_vm._v(_vm._s(_vm.$t('Search.status.pick')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Transit"
    }
  }, [_vm._v(_vm._s(_vm.$t('Search.status.transit')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Drop"
    }
  }, [_vm._v(_vm._s(_vm.$t('Search.status.drop')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Cancel"
    }
  }, [_vm._v(_vm._s(_vm.$t('Search.status.canceled')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Terminée"
    }
  }, [_vm._v(_vm._s(_vm.$t('Search.status.finished')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Transférée"
    }
  }, [_vm._v(_vm._s(_vm.$t('Search.status.transfered')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Reject"
    }
  }, [_vm._v(_vm._s(_vm.$t('Search.status.rejected')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Attente"
    }
  }, [_vm._v(_vm._s(_vm.$t('Search.status.waiting')))])]), _vm._v(" "), _c('regular-input', {
    staticClass: "col-12 col-sm-6 col-lg-3 form-group",
    attrs: {
      "value": _vm.search.dateReceptionMin,
      "type": "date",
      "placeholder": "Date min"
    },
    on: {
      "input": function($event) {
        _vm.search.dateReceptionMin = $event
      }
    }
  }), _vm._v(" "), _c('regular-input', {
    staticClass: "col-12 col-sm-6 col-lg-3 form-group",
    attrs: {
      "value": _vm.search.dateReceptionMax,
      "type": "date",
      "placeholder": "Date max"
    },
    on: {
      "input": function($event) {
        _vm.search.dateReceptionMax = $event
      }
    }
  }), _vm._v(" "), _c('regular-datalist-driver', {
    staticClass: "col-12 col-sm-6 col-lg-3 form-group",
    attrs: {
      "value": _vm.search.driver,
      "secondList": _vm.liste,
      "placeholder": _vm.$t('Search.driver')
    },
    on: {
      "input": function($event) {
        _vm.search.driver = $event.value
      }
    }
  }), _vm._v(" "), _c('regular-input', {
    staticClass: "col-12 col-sm-6 col-lg-3 form-group",
    attrs: {
      "value": _vm.search.nbSageOne,
      "type": "text",
      "placeholder": _vm.$t('Search.sageone')
    },
    on: {
      "input": function($event) {
        _vm.search.nbSageOne = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-6"
  }, [_c('button', {
    staticClass: "btn btn-kne-orange w-100",
    on: {
      "click": function($event) {
        _vm.clear()
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('Search.clear')) + "\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6"
  }, [_c('button', {
    staticClass: "btn btn-kne-orange w-100",
    attrs: {
      "disabled": !_vm.oneInputFilled
    },
    on: {
      "click": function($event) {
        _vm.submitSearch()
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('Search.submit')) + "\n            ")])])], 1)]), _vm._v(" "), _c('paginate-links', {
    attrs: {
      "for": "orders",
      "hide-single-page": true,
      "limit": 5
    },
    on: {
      "change": _vm.setLastPage
    }
  }), _vm._v(" "), _c('paginate', {
    ref: "paginator",
    attrs: {
      "name": "orders",
      "tag": "div",
      "list": _vm.orders.deliveries,
      "per": 30
    }
  }, [(_vm.orders.deliveries.length > 0) ? _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-hover font-grey mb-0 table-sm"
  }, [_c('thead', {
    staticClass: "bg-darkgrey"
  }, [_c('tr', [_c('th', {
    staticClass: "sortable nowrap",
    on: {
      "click": function($event) {
        _vm.sortBy('orderNb', false)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('OrderCurrent.order'))), (_vm.sort.current === 'orderNb') ? _c('i', {
    staticClass: "ml-1 fa",
    class: {
      'fa-arrow-down': _vm.sort.desc, 'fa-arrow-up': !_vm.sort.desc
    },
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e()]), _vm._v(" "), _c('th', {
    staticClass: "sortable nowrap",
    on: {
      "click": function($event) {
        _vm.sortBy('reference', false)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('OrderCurrent.reference'))), (_vm.sort.current === 'reference') ? _c('i', {
    staticClass: "ml-1 fa",
    class: {
      'fa-arrow-down': _vm.sort.desc, 'fa-arrow-up': !_vm.sort.desc
    },
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e()]), _vm._v(" "), _c('th', {
    staticClass: "sortable nowrap",
    on: {
      "click": function($event) {
        _vm.sortBy('source', false)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('OrderCurrent.source'))), (_vm.sort.current === 'source') ? _c('i', {
    staticClass: "ml-1 fa",
    class: {
      'fa-arrow-down': _vm.sort.desc, 'fa-arrow-up': !_vm.sort.desc
    },
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e()]), _vm._v(" "), _c('th', {
    staticClass: "sortable nowrap",
    on: {
      "click": function($event) {
        _vm.sortBy('vin', false)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('OrderCurrent.VIN'))), (_vm.sort.current === 'vin') ? _c('i', {
    staticClass: "ml-1 fa",
    class: {
      'fa-arrow-down': _vm.sort.desc, 'fa-arrow-up': !_vm.sort.desc
    },
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e()]), _vm._v(" "), _c('th', {
    staticClass: "sortable nowrap",
    on: {
      "click": function($event) {
        _vm.sortBy('date', false)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('OrderCurrent.date'))), (_vm.sort.current === 'date') ? _c('i', {
    staticClass: "ml-1 fa",
    class: {
      'fa-arrow-down': _vm.sort.desc, 'fa-arrow-up': !_vm.sort.desc
    },
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e()]), _vm._v(" "), _c('th', {
    staticClass: "sortable nowrap",
    on: {
      "click": function($event) {
        _vm.sortBy('pickup', false)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('OrderCurrent.pickup'))), (_vm.sort.current === 'pickup') ? _c('i', {
    staticClass: "ml-1 fa",
    class: {
      'fa-arrow-down': _vm.sort.desc, 'fa-arrow-up': !_vm.sort.desc
    },
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e()]), _vm._v(" "), _c('th', {
    staticClass: "sortable nowrap",
    on: {
      "click": function($event) {
        _vm.sortBy('delivery', false)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('OrderCurrent.delivery'))), (_vm.sort.current === 'delivery') ? _c('i', {
    staticClass: "ml-1 fa",
    class: {
      'fa-arrow-down': _vm.sort.desc, 'fa-arrow-up': !_vm.sort.desc
    },
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e()]), _vm._v(" "), _c('th', {
    staticClass: "sortable nowrap",
    on: {
      "click": function($event) {
        _vm.sortBy('billing', false)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('OrderCurrent.billing'))), (_vm.sort.current === 'billing') ? _c('i', {
    staticClass: "ml-1 fa",
    class: {
      'fa-arrow-down': _vm.sort.desc, 'fa-arrow-up': !_vm.sort.desc
    },
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e()]), _vm._v(" "), _c('th', {
    staticClass: "sortable nowrap",
    on: {
      "click": function($event) {
        _vm.sortBy('status', false)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('OrderCurrent.status'))), (_vm.sort.current === 'status') ? _c('i', {
    staticClass: "ml-1 fa",
    class: {
      'fa-arrow-down': _vm.sort.desc, 'fa-arrow-up': !_vm.sort.desc
    },
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e()]), _vm._v(" "), _c('th', {
    staticClass: "sortable nowrap",
    on: {
      "click": function($event) {
        _vm.sortBy('driver', false)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('OrderCurrent.driver'))), (_vm.sort.current === 'driver') ? _c('i', {
    staticClass: "ml-1 fa",
    class: {
      'fa-arrow-down': _vm.sort.desc, 'fa-arrow-up': !_vm.sort.desc
    },
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e()]), _vm._v(" "), _c('th')])]), _vm._v(" "), _c('transition-group', {
    attrs: {
      "name": "fade",
      "tag": "tbody"
    }
  }, _vm._l((_vm.paginated('orders')), function(order) {
    return _c('tr', {
      key: order.orderNb,
      class: {
        'drop': order.status === 'Drop', 'cancel': order.status === 'Cancel', 'waiting': order.status === 'Attente', 'pick': order.status === 'Pick', 'transit': order.status === 'Transit', 'dispatch': order.status === 'Dispatch', 'reject': order.status === 'Reject',
      }
    }, [_c('td', {
      staticClass: "nowrap"
    }, [_vm._v(_vm._s(order.orderNb))]), _vm._v(" "), _c('th', {
      staticClass: "nowrap"
    }, [_vm._v(_vm._s(order.reference))]), _vm._v(" "), _c('td', {
      staticClass: "nowrap"
    }, [_c('p', {
      staticClass: "table-fix-width"
    }, [_vm._v(_vm._s(order.source))])]), _vm._v(" "), _c('td', {
      staticClass: "nowrap"
    }, [_vm._v(_vm._s(order.vin))]), _vm._v(" "), _c('th', {
      staticClass: "nowrap"
    }, [_c('p', {
      staticClass: "table-fix-width"
    }, [_vm._v(_vm._s(_vm.getDate(order.date)))])]), _vm._v(" "), _c('th', {
      staticClass: "nowrap"
    }, [_c('p', {
      staticClass: "table-fix-width"
    }, [_vm._v(_vm._s(order.pickup))])]), _vm._v(" "), _c('th', {
      staticClass: "nowrap"
    }, [_c('p', {
      staticClass: "table-fix-width"
    }, [_vm._v(_vm._s(order.delivery))])]), _vm._v(" "), _c('th', {
      staticClass: "nowrap"
    }, [_c('p', {
      staticClass: "table-fix-width"
    }, [_vm._v(_vm._s(order.billing))])]), _vm._v(" "), _c('th', {
      staticClass: "nowrap"
    }, [(order.status === 'Dispatch') ? _c('span', [_vm._v(_vm._s(_vm.$t('Search.status.dispatch')))]) : _vm._e(), _vm._v(" "), (order.status === 'Processing') ? _c('span', [_vm._v(_vm._s(_vm.$t('Search.status.processing')))]) : _vm._e(), _vm._v(" "), (order.status === 'Pick') ? _c('span', [_vm._v(_vm._s(_vm.$t('Search.status.pick')))]) : _vm._e(), _vm._v(" "), (order.status === 'Attente') ? _c('span', [_vm._v(_vm._s(_vm.$t('Search.status.waiting')))]) : _vm._e(), _vm._v(" "), (order.status === 'Transit') ? _c('span', [_vm._v(_vm._s(_vm.$t('Search.status.transit')))]) : _vm._e(), _vm._v(" "), (order.status === 'Drop') ? _c('span', [_vm._v(_vm._s(_vm.$t('Search.status.drop')))]) : _vm._e(), _vm._v(" "), (order.status === 'Cancel') ? _c('span', [_vm._v(_vm._s(_vm.$t('Search.status.canceled')))]) : _vm._e(), _vm._v(" "), (order.status === 'Terminée') ? _c('span', [_vm._v(_vm._s(_vm.$t('Search.status.finished')))]) : _vm._e(), _vm._v(" "), (order.status === 'Transférée') ? _c('span', [_vm._v(_vm._s(_vm.$t('Search.status.transfered')))]) : _vm._e(), _vm._v(" "), (order.status === 'Reject') ? _c('span', [_vm._v(_vm._s(_vm.$t('Search.status.rejected')))]) : _vm._e()]), _vm._v(" "), _c('th', {
      staticClass: "nowrap"
    }, [_c('p', {
      staticClass: "table-fix-width"
    }, [_vm._v(_vm._s(order.driver))])]), _vm._v(" "), _c('td', [_c('a', {
      attrs: {
        "href": '#/OrderInfo?orderId=' + order.orderNb
      }
    }, [_c('input', {
      staticClass: "btn btn-kne-orange pull-right",
      attrs: {
        "type": "button",
        "value": _vm.$t('OrderCurrent.view')
      }
    })])])])
  }))], 1)]) : _vm._e()]), _vm._v(" "), _c('paginate-links', {
    attrs: {
      "for": "orders",
      "hide-single-page": true,
      "limit": 5
    },
    on: {
      "change": _vm.setLastPage
    }
  })], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-47ffceba","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/view/Search.vue
// module id = 837
// module chunks = 1